import { createFileRoute } from "@tanstack/react-router";

import { GymDetail } from "@/features/training/modules/gyms/gym-detail";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/gyms/$gymId")({
  loader: () => ({ crumb: m.gyms_place_title() }),
  component: GymPage,
});

function GymPage() {
  const { gymId } = Route.useParams();
  return <GymDetail gymId={gymId} />;
}
